import ContentLoader from 'react-content-loader';

export const HeadlineLoader = ({ className }: { className?: string }) => {
  return (
    <ContentLoader
      uniqueKey="headline-loader-key"
      className={className}
      style={{ width: '400px', height: '65px' }}
    >
      <rect x="0" y="0" rx="5" ry="5" width="350" height="35" />
      <rect x="0" y="45" rx="5" ry="5" width="150" height="20" />
    </ContentLoader>
  );
};
